export default __webpack_public_path__ + "static/media/utilsservice_openapi.99a2bd78.yml";